import { createStore, applyMiddleware } from "redux";
import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension';
import thunk from "redux-thunk";
import rootReducer from "./reducers";
//  Create React history to use inside redux store.
import { createBrowserHistory } from "history";
const history = createBrowserHistory();

const initialState = {};

const middleware = [thunk];

let store;
if ([
    "development",
    "triage",
    "staging"
].includes(process.env.NODE_ENV)) {
    store = createStore(
        rootReducer,
        initialState,
        composeWithDevToolsDevelopmentOnly(applyMiddleware(...middleware))
    );
}
else {
    store = createStore(
        rootReducer,
        initialState,
        applyMiddleware(...middleware)
    );
}

console.debug({ env: process.env.NODE_ENV });

export { history };
export default store;